import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import 'views/panels/hospital/PatientAssessment/index.scss'
import AssessmentForm from 'views/panels/hospital/PatientAssessment/AssessmentForm'

const PatientAssessment = ({
  isOpenModal,
  form,
  componentKey,
  designerPropsData,
  closeExternalModal,
  onCancelAssessment,
}) => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const hn = queryParams.get('hn')
  const vn = queryParams.get('vn')
  const an = queryParams.get('an')
  const [activeForm, setActiveForm] = useState({})

  useEffect(() => {
    setActiveForm({
      ...form,
      hn,
      vn,
      an,
    })
  }, [form])

  const onCloseCallback = () => {
    onCancelAssessment()
  }

  const onSaveCallback = (result) => {
    let { props = [] } = designerPropsData
    let receiveProps = props.filter(
      ({ elementKey }) => elementKey === componentKey
    )
    setActiveForm({})
    closeExternalModal(result, receiveProps)
  }

  const AssessmentCardForm = () => {
    return (
      <Card>
        <Card.Header>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Card.Title>
              {activeForm.name} , HN : {activeForm.hn}
            </Card.Title>
          </div>
        </Card.Header>
        <Card.Body>
          <AssessmentForm
            form={activeForm}
            onClose={onCloseCallback}
            onSaveCallback={onSaveCallback}
          />
        </Card.Body>
      </Card>
    )
  }

  return (
    <div className="assessment-archive">
      {isOpenModal && <AssessmentCardForm />}
    </div>
  )
}

export default PatientAssessment
